<template>
  <app-loading-section class="tab-loading-section" :loading="isLoading">
    <stats-team-chart :chart-data="tasks"/>
  </app-loading-section>
</template>

<script>
import StatsTeamChart from "./StatsTeamChart.vue";
import api from "../../../api";
import utils from "../../../services/utils";

export default {
  name: "StatsTeamTasks",
  components: {
    StatsTeamChart,
  },
  data() {
    return {
      isLoading: true,
      tasks: [],
      chartTemplate: {
        label: '',
        total: 0,
        chart: {
          labels: [],
          datasets: [{
            label: '',
            ids: [],
            data: [],
            backgroundColor: [],
            hoverOffset: 4,
            borderWidth: 4,
          }]
        }
      },
    }
  },
  watch: {
    'activeTab' () {
      if (this.activeTab === 'StatsTeamTasks') {
        this.loadStats()
      }
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters['statsTeam/getActiveTab']
    },
    statFilter() {
      return this.$store.getters['statsTeam/getFilters']
    },
    chartBgColors() {
      return this.$store.getters['statsTeam/getChartBackgroundColors']
    },
  },
  methods: {
    loadStats() {
      this.isLoading = true
      this.tasks = []

      const data = {
        start_at: this.statFilter.timeFrameValues.start,
        end_at: this.statFilter.timeFrameValues.end,
        users: this.statFilter.users
      }

      Promise.all([
        api.statsTeam.getAssignedTasks(data),
        api.statsTeam.getCompletedTasks(data),
        api.statsTeam.getCompletedLateTasks(data),
        api.statsTeam.getIncompleteTasks(data),
        api.statsTeam.getIncompleteAndPastDueTasks(data),
        api.statsTeam.getCompletionRateTasks(data)
      ]).then(([
        resAssignedTasks,
        resCompletedTasks,
        resCompletedLateTasks,
        resIncompleteTasks,
        resIncompleteAndPastDueTasks,
        resCompletionRateTasks
      ]) => {
        this.tasks.push(
          this.formatResponse('Assigned Tasks', resAssignedTasks.data),
          this.formatResponse('Total Completed Tasks', resCompletedTasks.data),
          this.formatResponse('Tasks Completed Late', resCompletedLateTasks.data),
          this.formatResponse('Total Incomplete Tasks', resIncompleteTasks.data),
          this.formatResponse('Incomplete and Past Due Tasks', resIncompleteAndPastDueTasks.data),
          this.formatResponse('Task Completion Rate', resCompletionRateTasks.data, true),
        )
      })
      .finally(() => this.isLoading = false)
    },
    formatResponse(label, response, isRate = false) {
      let chartData = utils.clone(this.chartTemplate)

      chartData.label = label
      if (response.length === 0) return chartData

      chartData.total = response.reduce((accumulator, res) => accumulator + res.total, 0)
      if (chartData.total) {
        if (isRate) chartData.total = utils.formatDigit(chartData.total / response.length, 1)

        chartData.chart.labels = response.map(res => res.user_name)
        chartData.chart.datasets[0].label = label

        response.forEach(res => {
          chartData.chart.datasets[0].ids.push(res.user_id)
          chartData.chart.datasets[0].data.push(res.total)

          const bgColor = this.chartBgColors.find(color => color.userId === res.user_id)
          if (bgColor) {
            chartData.chart.datasets[0].backgroundColor.push(bgColor.color)
          }
        })
      }

      return chartData
    }
  },
}
</script>

<style scoped lang="scss">

</style>
